import { getLanguageLabel } from './languageLabel'

/**
 * The `AUTO → <language>` chip on a meeting row.
 *
 * Source is not shown because it is not chosen: every meeting detects it, and a chip reading AUTO
 * on every row is the honest rendering of that. Only the target is the reader's decision.
 *
 * Its own file so the Recent and Ongoing rows render the same chip rather than two copies that
 * drift — they sit one above the other, and a difference between them would read as a difference
 * in kind.
 */
export default function LanguagePair({ targetLang }: { targetLang: string }) {
  return (
    <div className="flex items-center gap-1.5 text-xs text-[var(--text-tertiary)]">
      <span className="rounded bg-[var(--accent)] px-1.5 py-0.5 text-[10px] font-bold text-white">
        AUTO
      </span>
      <span aria-hidden="true">→</span>
      <span className="rounded bg-[var(--accent)] px-1.5 py-0.5 text-[10px] font-bold text-white">
        {getLanguageLabel(targetLang)}
      </span>
    </div>
  )
}
